import { render, staticRenderFns } from "./OurBeliefsIntroSection.vue?vue&type=template&id=837c979e"
import script from "./OurBeliefsIntroSection.vue?vue&type=script&lang=ts"
export * from "./OurBeliefsIntroSection.vue?vue&type=script&lang=ts"
import style0 from "./OurBeliefsIntroSection.vue?vue&type=style&index=0&id=837c979e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports